<template>
  <div>
    <form @submit.prevent>
      <div class="row align-bottom margin-bottom-md">
        <div class="column-12 laptop:column-8">
          <label
            v-if="hasArrivedFromFigma"
            for="email"
            class="margin-0 display-inline-block"
            style="cursor: pointer; font-weight: 700; color: var(--fa-dk-gravy)"
          >
            Enter your email to create a free account
          </label>

          <label
            v-else
            for="email"
            class="margin-0 display-inline-block"
            style="cursor: pointer; font-weight: 700; color: var(--fa-dk-gravy)"
          >
            Enter your email to
            <span class="display-none tablet:display-inline">get started</span>
            <span class="tablet:display-none">start</span>
            with a free Kit!
          </label>
          <a
            href="#"
            class="padding-x-3xs"
            @click.prevent="showWhyEmailModal"
          >
            <font-awesome-icon :icon="$v7.solid.faCircleQuestion" />
          </a>
        </div>
        <div
          v-if="isShowingCloudflare"
          class="display-none laptop:display-block laptop:column-4 text-right"
        >
          <a
            href="https://www.cloudflare.com/?utm_source=FontAwesome&utm_medium=website&utm_campaign=Marketing%20Sponsorship"
            class="text-nowrap"
            @click="$posthog.capture('referral:powered_by_cloudflare_link_click', { context: 'start_view' })"
          >
            <span class="size-sm">Powered by Cloudflare</span
            ><font-awesome-icon
              :icon="$v7.brands.faCloudflare"
              size="2xl"
              class="margin-left-3xs"
            />
          </a>
        </div>
      </div>

      <template v-if="errors.hasAny">
        <wa-message
          v-for="message in errors.messages"
          :key="message"
          theme="danger"
          :content="message"
          type="flash"
        />
      </template>
      <div class="row align-top">
        <div class="column-12 laptop:column-8">
          <input
            id="email"
            ref="email"
            v-model="email"
            name="email"
            class="margin-0"
            :class="{ danger: errors.hasAny }"
            type="email"
            placeholder="e.g. violet@freshsqueezed.org"
            autocapitalize="none"
            autocorrect="off"
            required
          />
          <wa-accept-policies-checkbox
            v-model="acceptPolicies"
            class="margin-top-md margin-bottom-xl laptop:margin-bottom-0"
          />
        </div>
        <div class="column-12 laptop:column-4">
          <wa-action-button
            v-if="hasArrivedFromFigma"
            :is-processing="isSending"
            icon-name="faRocketLaunch"
            is-full-width
            is-processing-label="Sending..."
            label="Create Your Free Account"
            theme="accent"
            style="--form-button-margin: 0"
            @click="initiateFreeAccount"
          />
          <wa-action-button
            v-else
            :is-processing="isSending"
            icon-name="faGlobe"
            is-full-width
            is-processing-label="Setting up..."
            label="Start for Free"
            theme="info"
            style="--form-button-margin: 0; --button-hover-background: var(--fa-yellow)"
            @click="initiateFreeAccount"
          />
          <div class="row align-middle margin-top-xl laptop:margin-top-lg">
            <div
              v-if="isShowingCloudflare"
              class="column-4 tablet:column-7 laptop:display-none"
            >
              <a
                href="https://www.cloudflare.com/?utm_source=FontAwesome&utm_medium=website&utm_campaign=Marketing%20Sponsorship"
                class="text-nowrap"
                @click="$posthog.capture('referral:powered_by_cloudflare_link_click', { context: 'start_view' })"
              >
                <span class="size-sm">Powered by Cloudflare</span
                ><font-awesome-icon
                  :icon="$v7.brands.faCloudflare"
                  size="2xl"
                  class="margin-left-3xs"
                />
              </a>
            </div>
            <div :class="['column-8 laptop:column-12 text-right', isShowingCloudflare ? 'tablet:column-5' : 'tablet:column-12']">
              <site-link
                :to="routes.signIn.location"
                class="display-inline-block"
                @click.native="$posthog.capture('sign_in_button_click', { context: 'start_view' })"
              >
                <span class="size-sm">Already have an account?</span>
              </site-link>
            </div>
          </div>
        </div>
      </div>
    </form>
    <modal-why-email
      :is-showing="isShowingWhyEmailModal"
      :has-arrived-from-figma="hasArrivedFromFigma"
      @close-modal="hideWhyEmailModal"
    />
  </div>
</template>

<script>
  import { PageHeaderRoutes } from 'app/components-wa/PageHeader/mixins'
  import { StartMixin } from 'app/views/start/mixins'
  import ModalWhyEmail from './ModalWhyEmail'

  export default {
    name: 'StartForm',

    components: {
      ModalWhyEmail
    },

    mixins: [PageHeaderRoutes, StartMixin],

    props: {
      isShowingCloudflare: {
        type: Boolean,
        default: false
      },
      hasArrivedFromFigma: {
        type: Boolean
      }
    },

    data() {
      return {
        isShowingWhyEmailModal: false
      }
    },

    mounted() {
      this.$posthog.capture('start_view', this.determinationsEventProps)
    },

    methods: {
      showWhyEmailModal() {
        this.$posthog.capture('start:why_need_email_modal_view')
        this.isShowingWhyEmailModal = true
      },

      hideWhyEmailModal() {
        this.isShowingWhyEmailModal = false
      }
    }
  }
</script>
